
import { Component, Mixins } from "vue-property-decorator";
import { Size } from "../../../../../domain/drawing";

@Component({
})
export default class CircleDrawableMixin extends Mixins() {
  size: Size;

  get radius(): Size {
    return this.size.multiply(0.5);
  }
}
